const whitelist = {
  page: true
};

export const removeURLParameter = (url, parameter) => {
  const params = new URLSearchParams(url);
  params.delete(parameter);
  return params.toString();
};

const getCmsCanonicalUrl = (router) => {
  const { asPath } = router;
  const [url, queries] = asPath.split('?');

  if (!queries) return url;

  const queryParams = new URLSearchParams(queries);
  queryParams.sort();

  const queriesObj = [...queryParams]
    .reduce((o, i) => ({ ...o, [i[0]]: i[1] }), {});

  const params = Object.keys(queriesObj).reduce((a, q) => {
    let temp = a;
    if (!whitelist[q]) temp = removeURLParameter(a, q);
    return temp;
  }, queryParams.toString());

  return `${url}${params ? `?${params}` : ''}`;
};

export default getCmsCanonicalUrl;
